import { XClose } from "@imwebme/clay-icons";
import { vars } from "@imwebme/clay-token";
import { Clay, Flex, Typography } from "../..";
import { Portal } from "../../utilities/Portal";
import { useTooltipContext } from "../Tooltip.provider";
import type { TooltipContentProps } from "./TooltipContent.types";
import { calculatePosition } from "./TooltipContent.utils";

export const TooltipContent = ({
  children,
  description,
  hasArrow,
  hasCloseButton,
  label,
  offsetX,
  offsetY,
  position,
  sx,
  className,
}: TooltipContentProps) => {
  const { portalRef, isOpen, setOff } = useTooltipContext();

  return isOpen ? (
    <Portal container={portalRef}>
      <Clay
        className={className}
        position="absolute"
        padding={description ? "12px 16px" : "6px 8px"}
        boxShadow={vars.dropShadow.layer}
        borderRadius={vars.rounded.medium}
        backgroundColor={vars.semantic.color.surface}
        cursor="default"
        sx={{
          ...calculatePosition({ position, offsetY, offsetX, hasArrow }),
          ...sx,
        }}
      >
        {hasCloseButton && (
          <Clay
            position="absolute"
            top="8px"
            right="8px"
            display="flex"
            cursor="pointer"
            native={{
              onClick: setOff,
            }}
          >
            <XClose />
          </Clay>
        )}

        <Flex.Column gap="8px" flex={1} alignItems="flex-start">
          {label && (
            <Typography variant="label-small-bold" whiteSpace="pre">
              {label}
            </Typography>
          )}

          {description && (
            <Typography variant="body-small" colorToken="textSub" textAlign="start">
              {description}
            </Typography>
          )}
        </Flex.Column>

        {children}
      </Clay>
    </Portal>
  ) : null;
};
